import { useState } from 'react';
import { useAdmin } from '../../hooks/useAdmin';
import PushNotifications from './PushNotifications';
import RecurringNotifications from './RecurringNotifications';

export default function NotificationsManager() {
  const { requireAdmin } = useAdmin();
  const [activeTab, setActiveTab] = useState<'immediate' | 'recurring'>('immediate');

  requireAdmin();

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      {/* Tab Navigation */}
      <div className="mb-6">
        <div className="border-b border-gray-200 dark:border-gray-700">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('immediate')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'immediate'
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
              }`}
            >
              Immediate Notifications
            </button>
            <button
              onClick={() => setActiveTab('recurring')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'recurring'
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
              }`}
            >
              Recurring Notifications
            </button>
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'immediate' && <PushNotifications />}
        {activeTab === 'recurring' && <RecurringNotifications />}
      </div>
    </div>
  );
}
